export default "__VITE_ASSET__qQqEGLrV__"